import React, { useState } from 'react';
//import '../../style/dashboard.css'; // Estilos gerais
import { Form, Button, Row, Col, Container, Alert, Nav, Navbar, Tab, Table, Modal, ButtonGroup } from 'react-bootstrap';
import FormEmail from '../../components/config/formEmail';

const Config = () => {

    const [key, setKey] = useState('email');

    return (
        <div className="dashboard-container">
            <Row>
                <h2 className='text-center'>Configurações</h2>
                {/* {error && <Alert className='text-center' variant="danger">{error}</Alert>}
                {success && <Alert className='text-center' variant="success">Avaliação salva com sucesso!</Alert>}*/}
                <div className='nav-avaliacao'>
                    <Navbar expand="lg">

                        <Nav className="mr-auto">
                            <Nav.Link eventKey="email" onClick={() => setKey('email')}>Email</Nav.Link>
                            {/*<Nav.Link eventKey="tipos" onClick={() => setKey('tipos')}>Tipos</Nav.Link>
                            <Nav.Link eventKey="caracteristicas" onClick={() => setKey('caracteristicas')}>Características</Nav.Link>
                            <Nav.Link eventKey="modelos" onClick={() => setKey('modelos')}>Modelos</Nav.Link>*/}
                        </Nav>
                    </Navbar>
                </div>

                <Tab.Content>
                    <Tab.Pane eventKey="email" active={key === 'email'}>
                        {key === 'email' && <FormEmail/>}
                    </Tab.Pane>
                   {/*} <Tab.Pane eventKey="tipos" active={key === 'tipos'}>
                        {key === 'tipos' && <FormularioTipo />}
                    </Tab.Pane>
                    <Tab.Pane eventKey="caracteristicas" active={key === 'caracteristicas'}>
                        {key === 'caracteristicas' && <FormularioCaracteristicas />}
                    </Tab.Pane>
                    <Tab.Pane eventKey="modelos" active={key === 'modelos'}>
                        {key === 'modelos' && <FormularioModelos />}
                    </Tab.Pane>*/}
                </Tab.Content>

            </Row>
        </div>
    );
};

export default Config;
